import Text from "ab-text";

import "./ab-confiado.scss";

const Confiado = ({ title = "Han confiado en nosotros", logos }) => {
  return (
    <div className="ab-confiado">
      <div className="details">
        <Text element="h2" animated>
          {title}
        </Text>
      </div>
      <div className="logos">
        {logos ? (
          logos.map((itm) => <img src={itm.mediaItemUrl} />)
        ) : (
          <>
            <img src="/images/escuela-cocina.png" />
            <img src="/images/basque-culinary.png" />
            <img src="/images/el-celler.png" />
            <img src="/images/camara.png" />
            <img src="/images/viniteca.png" />
            <img src="/images/lavinia.png" />
            <img src="/images/cett.png" />{" "}
          </>
        )}
      </div>
    </div>
  );
};

export default Confiado;
